import { integratorBaseModel } from './crud';
// eslint-disable-next-line
import { fetchEhrIntegratorsConfigurationByIntegratorName } from './fetchEHRIntegratorsConfigurationByIntegratorName';
import { fetchEhrIntegratorsConfiguration } from './fetchIntegratorsConfiguration';

export * from './types';

export const useIntegratorsById = integratorBaseModel.fetchById();
export const useIntegratorsByIds = integratorBaseModel.fetchByIds();
export const useIntegratorsMany = integratorBaseModel.fetchMany();
export const useIntegratorsCount = integratorBaseModel.count();
export const useIntegratorsManyInfiniteQuery =
  integratorBaseModel.fetchPaginated();
export const useIntegratorsUpdateOne = integratorBaseModel.edit();
export const useIntegratorsCreateOne = integratorBaseModel.create();
export const useIntegratorsRemoveOne = integratorBaseModel.delete();
export const useIntegratorsRemoveByIds = integratorBaseModel.deleteByIds();

export const useIntegratorsByIdV2 = integratorBaseModel.fetchByIdV2();
export const useIntegratorsByIdsV2 = integratorBaseModel.fetchByIdsV2();
export const useIntegratorsManyV2 = integratorBaseModel.fetchManyV2();
export const useIntegratorsCountV2 = integratorBaseModel.countV2();
export const useIntegratorsManyInfiniteQueryV2 =
  integratorBaseModel.fetchPaginatedV2();
export const useIntegratorsUpdateOneV2 = integratorBaseModel.editV2();
export const useIntegratorsCreateOneV2 = integratorBaseModel.createV2();
export const useIntegratorsRemoveOneV2 = integratorBaseModel.deleteV2();
export const useIntegratorsRemoveByIdsV2 = integratorBaseModel.deleteByIdsV2();

export const useEhrIntegratorConfiguration = fetchEhrIntegratorsConfiguration();
export const useEhrIntegratorConfigurationByIntegratorName =
  fetchEhrIntegratorsConfigurationByIntegratorName();

// New names based on Mongoose queries
export const useIntegratorById = integratorBaseModel.fetchById();
export const useIntegratorByIds = integratorBaseModel.fetchByIds();
export const useIntegratorMany = integratorBaseModel.fetchMany();
export const useIntegratorCount = integratorBaseModel.count();
export const useIntegratorPagination = integratorBaseModel.fetchPaginated();
export const useIntegratorUpdateOne = integratorBaseModel.edit();
export const useIntegratorCreateOne = integratorBaseModel.create();
export const useIntegratorRemoveOne = integratorBaseModel.delete();
export const useIntegratorRemoveByIds = integratorBaseModel.deleteByIds();

export const useIntegratorByIdV2 = integratorBaseModel.fetchByIdV2();
export const useIntegratorByIdsV2 = integratorBaseModel.fetchByIdsV2();
export const useIntegratorManyV2 = integratorBaseModel.fetchManyV2();
export const useIntegratorCountV2 = integratorBaseModel.countV2();
export const useIntegratorPaginationV2 = integratorBaseModel.fetchPaginatedV2();
export const useIntegratorUpdateOneV2 = integratorBaseModel.editV2();
export const useIntegratorCreateOneV2 = integratorBaseModel.createV2();
export const useIntegratorRemoveOneV2 = integratorBaseModel.deleteV2();
export const useIntegratorRemoveByIdsV2 = integratorBaseModel.deleteByIdsV2();
